import { NAME } from "./constants";

export const getCrowdContentOrderKeywords = (state) => {
  return state.pages.projectView.modalData.addCrowdContentOrder[NAME].keywords;
};
